import React from "react";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomText from "pages/_components/CustomText/CustomText";
import FormattedAmount from "pages/_components/FormattedAmount";
import Image from "../../_components/Image";
import classNames from "classnames";
import { isIOS } from "react-device-detect";
import * as i18n from "util/i18n";

/**
 * Componente que muestra el total de echeqs seleccionados y el monto total.
 * @param {Object} props
 * @param {number} selectedCount - Cantidad de echeqs seleccionados
 * @param {number} totalAmount - Monto total de los echeqs seleccionados
 * @param {boolean} isDesktop - Si es vista desktop
 */
const EcheqTotalizer = ({ selectedCount, totalAmount, selectedCurrency, isDesktop }) => {
    if (!selectedCount) return null;
    return (
        <GridTable className="summary-selected-items-table box mt-6 box-shadow">
            <GridTable.Container columns={3} rows={2}>
                <GridTable.Data
                    columnStart={1}
                    rowStart={1}
                    rowWidth={isDesktop ? 2 : 1}>
                    <div className="discount-bubble-wrapper">
                        <Image
                            src={
                                isIOS
                                    ? "images/figma/icon/success-primary.svg"
                                    : "images/figma/icon/success.svg"
                            }
                            className={classNames("svg-icon")}
                        />
                        <CustomText text={`${selectedCount} ${i18n.get("echecks.selected.echeqs")}`} />
                    </div>
                </GridTable.Data>
                {!isDesktop && (
                    <GridTable.Data
                        className={isIOS ? "line-dashed-wrapper" : null}
                        columnStart={1}
                        rowStart={2}
                        columnWidth={2}>
                        <div className="line-dashed" />
                    </GridTable.Data>
                )}
                <GridTable.Data
                    alignX="end"
                    columnStart={2}
                    rowStart={isDesktop ? 1 : 3}
                    columnWidth={1}>
                    <CustomText text="echecks.monto.total" textType="I18N" />
                </GridTable.Data>
                <GridTable.Data
                    alignX="end"
                    columnStart={2}
                    rowStart={isDesktop ? 2 : 4}
                    columnWidth={1}>
                    <FormattedAmount 
                        quantity={totalAmount} 
                        currency={selectedCurrency} />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable>
    );
};

export default EcheqTotalizer;